import { lazyPipe, validateApiResponse, withApiErrorCapture } from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import urlJoin from 'url-join';
import z from 'zod';
import { privateHttpClient } from '../httpClient';
import { createApiResponseSchema } from '../utils';
import { campaignsApiPath } from './apiPath';

const SeedingRejectionReasonSchema = z
  .object({
    code: z.string(),
    label: z.string(),
  })
  .describe('SeedingRejectionReason');

export type SeedingRejectionReason = z.infer<typeof SeedingRejectionReasonSchema>;

const GetSeedingProposalRejectionReasonsResponseDataSchema = z
  .object({
    reasons: z.array(SeedingRejectionReasonSchema),
  })
  .describe('GetSeedingProposalRejectionReasonsResponseData');

const GetSeedingProposalRejectionReasonsResponseSchema = createApiResponseSchema(
  GetSeedingProposalRejectionReasonsResponseDataSchema,
);

export type GetSeedingProposalRejectionReasonsResponse = z.infer<
  typeof GetSeedingProposalRejectionReasonsResponseSchema
>;

export const getSeedingProposalRejectionReasons = withApiErrorCapture(
  lazyPipe(
    async (): Promise<GetSeedingProposalRejectionReasonsResponse> =>
      executeStandardRequest(async () =>
        privateHttpClient.get<GetSeedingProposalRejectionReasonsResponse>(
          urlJoin(campaignsApiPath.getSeedingProposalRejectionReasons),
        ),
      ),
    validateApiResponse(GetSeedingProposalRejectionReasonsResponseSchema),
  ),
);
